import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'app-upfront-payment-slider',
  templateUrl: './upfront-payment-slider.component.html',
  styleUrls: ['./upfront-payment-slider.component.scss']
})
export class UpfrontPaymentSliderComponent implements AfterViewInit, OnInit {
  sliderData: any[] = [];
  outline = false;
  outlineActive=false

  
  constructor(private cdr:ChangeDetectorRef) {}

  ngOnInit(): void {
    this.loadData();
    window.addEventListener('scroll', this.toggleOutlineOnScroll);

  }
  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.toggleOutlineOnScroll);
  }
  ngAfterViewInit(): void {
    // setTimeout(() => {
      this.initScrollAnimation();

    // }, 200);
  }
  toggleOutlineOnScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 200) {
      this.outlineActive = true;
    } else {
      this.outlineActive = false;
    }
  }
  loadData() {
    this.sliderData = sliderData;
        // this.initScrollAnimation();

  }

  refresh() {
    this.loadData();
  }
  initScrollAnimation(): void {
    const cards = document.querySelector('.cards');
    const header = document.querySelector('.maxContainer');
    const cardItems = gsap.utils.toArray(".card-item");
    const spacer = 0;
    const minScale = 0.8;

    const distributor = gsap.utils.distribute({ base: minScale, amount: 0.2 });

    let mmStack = gsap.matchMedia();
    mmStack.add("(min-width: 1024px)", () => {
      cardItems.forEach((card: any, index: number) => {
        const scaleVal = distributor(index, cardItems[index], cardItems);

        gsap.to(card, {
          scrollTrigger: {
            trigger: card,
            start: "clamp( bottom center)",
            scrub: true,
            invalidateOnRefresh: true,
            id: "card-item",
            onUpdate: (self) => {
              this.updateOutline(self.isActive);
            }
          },
          ease: "none",
          // scale: scaleVal
        });

        ScrollTrigger.create({
          trigger: card,
          start: `top-=${index * spacer} top`,
          endTrigger: ".cards",
          end: `bottom bottom+=${cardItems.length * spacer}`,
          pin: true,
          pinSpacing: false,
          invalidateOnRefresh: true,
          id: "pin",
        });
      });
    });
    // mmStack.add("(max-width: 1023px)", () => {
    //   cardItems.forEach((card: any, index: number) => {
    //     const scaleVal = distributor(index, cardItems[index], cardItems);

    //     gsap.to(card, {
    //       scrollTrigger: {
    //         trigger: card,
    //         start: "clamp( bottom center)",
    //         scrub: true,
    //         invalidateOnRefresh: true,
    //         id: "card-item",
    //         onUpdate: (self) => {
    //           this.updateOutline(self.isActive);
    //         }
    //       },
    //       ease: "none",
    //       // scale: scaleVal
    //     });

    //     ScrollTrigger.create({
    //       trigger: card,
    //       start: `top-=${index * 20} top`,
    //       // endTrigger: ".cards",
    //       end: `bottom bottom+=${cardItems.length *20}`,
    //       pin: true,
    //       pinSpacing: false,
    //       invalidateOnRefresh: true,
    //       id: "pin",
    //     });
    //   });
    // });
  }
  updateOutline(isActive: boolean) {
    if (isActive) {
      this.outline = true;
    } else {
      this.outline = false
    }
    this.outline = isActive;
    this.cdr.detectChanges();
  }
}

export const sliderData = [
  { imageURL: 'upfrontImg1.png', text: "Book Parcels with PostEx", heading: 'Instant upfront payments', upfront: 'How Upfront Payments Work' },
  { imageURL: 'upfrontImg2.png', text: "PostEx Picks Your Parcel from Doorstep" },
  { imageURL: 'upfrontImg3.png', text: "Upfront Payment Transferred Instantly" },
];
